/*
 * @description: 
 * @Author: Loadman
 * @Date: 2020-11-11 18:28:07
 * @LastEditors: Loadman
 * @LastEditTime: 2020-11-11 18:52:48
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css'
import axios from 'axios'
import qs from 'qs';

Vue.use(ElementUI);

Vue.config.productionTip = false

// axios.defaults.withCredentials = true; // 跨域
const api = axios.create({
  headers:{'Content-Type': 'application/x-www-form-urlencoded'},
});
// 添加请求拦截器
api.interceptors.request.use(async (config) => {
  return config;
});
// 添加响应拦截器
api.interceptors.response.use(async (response) => {
  return response;
});

//get
function autoGetMeth(data,url){
  return api.get(url+"?"+qs.stringify(data));
}
//post
function autoPostMeth(data,url){
  return api.post(url,qs.stringify(data));
}

Vue.prototype.$autGet = autoGetMeth;
Vue.prototype.$autPost = autoPostMeth;

Vue.prototype.$getUrl = 'http://www.gr-environment.com/web/api' 

Vue.prototype.$getDataUrl = Vue.prototype.$getUrl + '/grhb/webList'; //获取新闻
Vue.prototype.$getMenuUrl = Vue.prototype.$getUrl + '/grhb/webMenu'; //获取菜单
Vue.prototype.$getAddUrl = Vue.prototype.$getUrl + '/grhb/add'; //获取菜单
Vue.prototype.$getDetailUrl = Vue.prototype.$getUrl + '/grhb/getDataById'; //获取菜单



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
